import { IOrganizationSubscriptionRenewalSuggestionMembershipPlanModel } from '../../../../../models/interfaces/Subscription/OrganizationSubscriptionRenewalSuggestionMembershipPlanModel';

export const calculateCapacity = (
  suggestion: IOrganizationSubscriptionRenewalSuggestionMembershipPlanModel,
  transferAllEligibleMembershipsValue: boolean,
) =>
  transferAllEligibleMembershipsValue
    ? suggestion.capacitySuggestion
    : suggestion.previousCapacity;
